import type { Apningstid } from '../../../types/verktoynetcoreentities';

export const getDayText = (index: number): string => {
  const daysArray = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'];
  return daysArray[index - 1];
};

const isWithinTime = (currentTime: string, fromTime?: string | null, toTime?: string | null): boolean => {
  if (!fromTime || !toTime) return false;
  return currentTime >= fromTime && currentTime <= toTime;
};

// Finner den første som har høyere dag index, ellers finn den første lavere
const getNextOpenDay = (currentDayIndex: number, openDays: Apningstid[]): Apningstid | undefined => {
  return (
    openDays.find(od => {
      return od.Dag > currentDayIndex && (typeof od.FraKl !== 'undefined' || od.ApenHeleDagen);
    }) ??
    openDays.find(od => {
      return od.Dag < currentDayIndex && (typeof od.FraKl !== 'undefined' || od.ApenHeleDagen);
    })
  );
};

export const getOpenClosedTexts = (openDates: Apningstid[]): { statusText: string; timeText: string } => {
  const currentDate = new Date();
  // Lokaliserer og garanterer 0 før tidspunkt - f.eks. blir 9:50 til 09:50
  const currentTime =
    currentDate.getHours().toLocaleString('nb-NO').padStart(2, '0') +
    ':' +
    currentDate.getMinutes().toLocaleString('nb-NO').padStart(2, '0');
  // Setter startindex til mandag (1), og sluttindex til søndag (7)
  const currentDayIndex = currentDate.getDay() === 0 ? 7 : currentDate.getDay();
  const currentOpenDate = openDates.find(od => od.Dag === currentDayIndex);
  const currentOpenFromTime = currentOpenDate?.FraKl;
  const currentOpenToTime = currentOpenDate?.TilKl;

  const isAfterOpeningHours =
    !currentOpenDate?.ApenHeleDagen && (!currentOpenToTime || typeof currentOpenToTime === 'undefined' || currentTime >= currentOpenToTime);
  const currentlyOpen = !isAfterOpeningHours && isWithinTime(currentTime, currentOpenFromTime, currentOpenToTime);
  const nextOpenDate = isAfterOpeningHours ? getNextOpenDay(currentDayIndex, openDates) : undefined;

  const statusText = currentlyOpen ? 'Åpent' : 'Stengt';

  const closingTimeText = `Stenger: ${currentOpenToTime}`;
  const openingTimeText = `Åpner: ${nextOpenDate ? getDayText(nextOpenDate.Dag) : ''} ${nextOpenDate?.FraKl ?? currentOpenFromTime}`;

  const timeText = currentlyOpen ? closingTimeText : openingTimeText;

  return { statusText: statusText, timeText: timeText };
};
